<template>
  <v-row align="center" justify="center" :class="is_mobile_screen || is_tablet_screen ? 'flex-column-reverse' : ''">
    <div v-if="is_mobile_screen" class="mobile-space"></div>
    <v-col cols="12" md="5" class="pr-md-10">
      <h2 class="mb-8 pl-1">
        {{language.dimensions.main_title}}
      </h2>
      <v-col cols="12" class="pa-0" @mouseover="bottom_arrow_active = true" @mouseleave="bottom_arrow_active = false">
        <div class="d-flex align-center justify-space-between px-2">
        <v-subheader class="px-0 subtitle-1">
          {{language.dimensions.subtitles.width}}
        </v-subheader>
        <span class="headline font-weight-light right"
          >{{ dimensions.lt }} {{language.dimensions.meters}}</span
        >
      </div>
      <v-slider 
        v-model="dimensions.lt" 
        min="1" 
        max="100"
        :thumb-label='sliderLabelShow'
        thumb-size="40"
        thumb-color="rgb(25, 118, 210,.7)"
        @start="showBottomArrow"
      ></v-slider>
      </v-col>
      <v-col cols="12" class="pa-0"  @mouseover="left_arrow_active = true" @mouseleave="left_arrow_active = false">
        <div class="d-flex align-center justify-space-between px-2">
        <v-subheader class="px-0 subtitle-1"
          >{{language.dimensions.subtitles.height}}</v-subheader
        >
        <span class="headline font-weight-light right">{{ hTotalaText }}</span>
      </div>
      <v-slider
        v-model="dimensions.ht"
        min="0.7"
        step="0.01"
        max="2.2"
        :thumb-label='sliderLabelShow'
        thumb-size="40"
        thumb-color="rgb(25, 118, 210,.7)"
        @start="showLeftArrow"
      ></v-slider>
      </v-col>
      <v-col cols="12" class="pa-0" @mouseover="small_arrow_active = true" @mouseleave="small_arrow_active = false">
        <div class="d-flex align-center justify-space-between px-2">
        <v-subheader class="px-0 subtitle-1">{{language.dimensions.subtitles.small_height}}</v-subheader>
        <span class="headline font-weight-light right">{{ parapetText }}</span>
      </div>
      <v-slider
        v-model="dimensions.hp"
        min="0"
        step="0.01"
        :max="hpMax"
        :thumb-label='sliderLabelShow'
        thumb-size="40"
        thumb-color="rgb(25, 118, 210,.7)"
        @start="showSmallArrow"
      ></v-slider>
      </v-col>
    </v-col>
    <v-col cols="12" md="7" class="mt-md-12">
      <div class="d-flex flex-nowrap">
        <v-img
          class="mx-auto flex-shrink-1"
          contain
          max-width="100%"
          :src="require('../assets/img/dimensions/'+imgLink)"
        >
        </v-img>
      </div>
    </v-col>
    <!-- <pre>{{$data.dimensions}}</pre> -->
  </v-row>
</template>

<script>
export default {
  name: "Dimensions",
  data: function () {
    return {
      dimensions: {
        lt: 20,
        ht: 1.9,
        hp: 0.9,
      },
      bottom_arrow_active: false,
      left_arrow_active: false,
      small_arrow_active: false,
    };
  },
  props: ["language", "is_mobile_screen", "is_tablet_screen", "model"],
  computed: {
    sliderLabelShow() {
      if (this.is_mobile_screen || this.is_tablet_screen) {
        return "always";
      } else {
        return true;
      }
    },
    hpMax() {
      return this.dimensions.ht - 0.4;
    },
    hTotalaText() {
      let pt = " " + this.language.dimensions.meters;
      let h = this.dimensions.ht;

      if (h == 1) {
        pt = " " + this.language.dimensions.meter;
      }
      return h + pt;
    },
    parapetText() {
      let pt = " " + this.language.dimensions.meters;
      let h = this.dimensions.hp;

      if (h == 1) {
        pt = " " + this.language.dimensions.meter;
      }
      return h + pt;
    },
    imgLink() {
      // default is
      let img = 1;

      if (this.bottom_arrow_active) {
        img = 4;
      } else if (this.left_arrow_active) {
        img = 2;
      } else if (this.small_arrow_active) {
        img = 3;
      }

      let name = "gard_" + this.model + "_" + String(img);
      return name + ".png";
    },
  },
  watch: {
    dimensions: {
      handler: function () {
        this.$emit("changeDims", this.dimensions);
      },
      deep: true,
    },
  },
  methods: {
    hideArrows() {
      this.bottom_arrow_active = false;
      this.left_arrow_active = false;
      this.small_arrow_active = false;
    },
    showBottomArrow() {
      this.hideArrows();
      this.bottom_arrow_active = true;
    },
    showLeftArrow() {
      this.hideArrows();
      this.left_arrow_active = true;
    },
    showSmallArrow() {
      this.hideArrows();
      this.small_arrow_active = true;
    },
  },
};
</script>

<style lang="css">
</style>
